import { AppState } from '../models/state/appState';

/*
 * Selects the filter account.
 */
export function selectAccount(state: AppState) {
  return state.filter && state.filter.account;
}

/*
 * Selects the filter company.
 */
export function selectCompany(state: AppState) {
  return state.filter.company;
}

/*
 * Selects the SIM submission.
 */
export function selectSimSubmission(state: AppState) {
  return state.filter.simSubmission;
}
